import React, { useState } from "react";
import { Link } from "@reach/router";
import styles from "./MammalChampion.module.scss";
import Username from "./Username";

function ShowUsernameButton(props) {
  const [showUsername, setShowUsername] = React.useState(false);
  const folk = props.folk;

  if (localStorage.getItem("factWhatIfUsername") === "") {
    return (
      <>
        <button
          className={styles.choice}
          onClick={(e) => {
            setShowUsername(!showUsername);
          }}
        >
          {showUsername && "Continue Without a Username"}
          {!showUsername && "Add a Username"}
        </button>

        {showUsername && <Username />}
      </>
    );
  } else {
    return (
      <>
        <Username />
      </>
    );
  }
}

export default ShowUsernameButton;
